import { Tooltip } from '@chakra-ui/react';
import { faCircleQuestion } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Container } from './styles';

interface IInputTooltipProps {
  label: string;
}

const InputTooltip: React.FC<IInputTooltipProps> = ({ label }) => (
  <Container className="input-tooltip">
    <Tooltip label={label} placement="top-start" hasArrow>
      <FontAwesomeIcon icon={faCircleQuestion} />
    </Tooltip>
  </Container>
);
export default InputTooltip;
